function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Breakpoints, Spacing, Text, ThemingContext } from '@doordash/design-language';
import Button, { IconButton } from '@doordash/component-button';
import { ModalCloseButtonContainer, ModalContainer, ModalContentContainer, ModalFooter, ModalFooterContainer, ModalStickyHeader, ModalContent as StyledModalContent } from './styles';
import DefaultContentHeader from './DefaultContentHeader';
import ExecutionEnvironment from 'exenv';
import NavBar from '@doordash/component-navbar';
import PropTypes from 'prop-types';
import React from 'react';
import { Sizes } from './constants';
import get from 'lodash.get';
import omit from 'lodash.omit';
import { withUniqueId } from '@doordash/utilities';

var getTitleId = function getTitleId(uniqueId) {
  return "".concat(uniqueId, "-Title");
};

var getSubtitleId = function getSubtitleId(uniqueId) {
  return "".concat(uniqueId, "-Subtitle");
};

var PREFIX_ID = 'ModalContent';

var ModalContent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ModalContent, _React$PureComponent);

  function ModalContent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModalContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModalContent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      topScrolled: false,
      bottomScrolled: false,
      footerPadding: 0
    });

    _defineProperty(_assertThisInitialized(_this), "setContentElement", function (el) {
      _this.contentElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "setFooterElement", function (el) {
      _this.footerElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "setTitleElement", function (el) {
      _this.titleElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.calculateScrollState(_this.contentElement);

      if (_this.props.isFooterFixedPosition) {
        _this.setFooterPadding(_this.footerElement);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (event) {
      _this.calculateScrollState(event.target);
    });

    _defineProperty(_assertThisInitialized(_this), "isMobileViewport", function () {
      return !!(window.innerWidth <= Breakpoints.Mobile);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateScrollState", function (scrollElement) {
      var scrollTop = scrollElement.scrollTop,
          scrollHeight = scrollElement.scrollHeight,
          offsetHeight = scrollElement.offsetHeight;

      if (typeof scrollTop !== 'undefined' && typeof scrollHeight !== 'undefined' && typeof offsetHeight !== 'undefined') {
        _this.setState({
          topScrolled: scrollTop > _this.titleElement.offsetTop + _this.titleElement.offsetHeight,
          bottomScrolled: scrollTop + offsetHeight < scrollHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setFooterPadding", function (footerElement) {
      if (footerElement === null || typeof footerElement === 'undefined' || !_this.isMobileViewport()) return;

      _this.setState({
        footerPadding: footerElement.offsetHeight
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentKeydown", function (event) {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          shouldCloseOnEscapePress = _this$props.shouldCloseOnEscapePress;

      if (onClose && shouldCloseOnEscapePress && event.keyCode === 27) {
        onClose();
      }
    });

    return _this;
  }

  _createClass(ModalContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (ExecutionEnvironment.canUseDOM) {
        this.calculateScrollState(this.contentElement);
        requestAnimationFrame(function () {
          return _this2.setFooterPadding(_this2.footerElement);
        });
        document.addEventListener('keydown', this.handleDocumentKeydown);
        window.addEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (ExecutionEnvironment.canUseDOM) {
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        window.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          headerAlignment = _this$props2.headerAlignment,
          children = _this$props2.children,
          hasContentPadding = _this$props2.hasContentPadding,
          headerImage = _this$props2.headerImage,
          actionsFillContainer = _this$props2.actionsFillContainer,
          primaryAction = _this$props2.primaryAction,
          hasCloseButton = _this$props2.hasCloseButton,
          onClose = _this$props2.onClose,
          secondaryAction = _this$props2.secondaryAction,
          size = _this$props2.size,
          subtitle = _this$props2.subtitle,
          title = _this$props2.title,
          uniqueId = _this$props2.uniqueId,
          role = _this$props2.role,
          ModalContentHeader = _this$props2.renderContentHeader,
          renderFooterContent = _this$props2.renderFooterContent,
          shouldStackButtons = _this$props2.shouldStackButtons,
          isFullScreenOnMobile = _this$props2.isFullScreenOnMobile,
          isFooterFixedPosition = _this$props2.isFooterFixedPosition;
      var closeButtonAccessibilityLabel = "Close ".concat(title, " modal");
      return React.createElement(ModalContainer, {
        modalBackgroundColor: get(this.context, 'Colors.ModalBackground'),
        modalBorderRadius: get(this.context, 'BorderRadius.ModalDefault'),
        size: size,
        role: role,
        "aria-modal": "true",
        "aria-labelledby": getTitleId(uniqueId),
        "aria-describedby": getSubtitleId(uniqueId),
        isFullScreenOnMobile: isFullScreenOnMobile
      }, React.createElement("span", {
        "aria-label": title,
        "aria-live": "polite",
        tabIndex: 0
      }), hasCloseButton && !this.state.topScrolled && (ModalContentHeader !== DefaultContentHeader || headerImage) && React.createElement(ModalCloseButtonContainer, {
        isFloating: !!headerImage,
        hasCustomHeader: ModalContentHeader !== DefaultContentHeader
      }, React.createElement(IconButton, {
        iconType: IconButton.IconTypes.Close,
        onClick: onClose,
        accessibilityLabel: closeButtonAccessibilityLabel,
        isRaised: !!headerImage
      })), this.state.topScrolled && React.createElement(ModalStickyHeader, {
        "aria-live": "polite",
        modalBackgroundColor: get(this.context, 'Colors.ModalBackground')
      }, React.createElement(NavBar, {
        isRaised: true,
        onNavigationClick: onClose,
        navigationType: hasCloseButton || !headerImage ? NavBar.NavigationTypes.Close : NavBar.NavigationTypes.None,
        strings: {
          navigationButtonLabel: hasCloseButton ? closeButtonAccessibilityLabel : null
        },
        textAlign: headerAlignment,
        title: title,
        titleSize: NavBar.TitleSizes.Small
      })), React.createElement(ModalContentContainer, {
        hasPadding: hasContentPadding,
        onScroll: this.handleScroll,
        innerRef: this.setContentElement,
        hasFooter: !!primaryAction,
        isFooterFixedPosition: isFooterFixedPosition
      }, React.createElement(ModalContentHeader, {
        closeButtonAccessibilityLabel: closeButtonAccessibilityLabel,
        title: React.createElement("span", {
          ref: this.setTitleElement
        }, title),
        subtitle: subtitle,
        onClose: onClose,
        headerAlignment: headerAlignment,
        headerImage: headerImage,
        hasContent: !!children,
        titleId: getTitleId(uniqueId),
        subtitleId: getSubtitleId(uniqueId),
        hasPadding: hasContentPadding,
        hasCloseButton: hasCloseButton
      }), children && React.createElement(StyledModalContent, {
        hasPadding: hasContentPadding // You need to be able to account for the footer
        // being out of normal flow by adding additional
        // padding to the content's container within the
        // scrollview:
        ,
        style: isFooterFixedPosition && this.isMobileViewport() ? {
          paddingBottom: this.state.footerPadding + Spacing.XxLarge
        } : undefined // Don't provide any style if not fixed

      }, children)), (!!primaryAction || !!renderFooterContent) && React.createElement(ModalFooterContainer, {
        modalSize: size,
        isFooterFixedPosition: isFooterFixedPosition,
        isFullScreenOnMobile: isFullScreenOnMobile
      }, React.createElement("div", {
        ref: this.setFooterElement
      }, React.createElement(ModalFooter, {
        modalBackgroundColor: get(this.context, 'Colors.ModalBackground'),
        shouldStackButtons: !hasCloseButton || shouldStackButtons,
        showDivider: this.state.bottomScrolled,
        actionsFillContainer: actionsFillContainer,
        isFullScreenOnMobile: isFullScreenOnMobile,
        isSquished: true
      }, !!renderFooterContent && renderFooterContent(), !!secondaryAction && React.createElement(Button, _extends({
        type: Button.Types.Tertiary,
        isInline: true,
        onClick: secondaryAction.onClick
      }, secondaryAction.buttonProps), secondaryAction.text), !!primaryAction && React.createElement(Button, _extends({
        isInline: true,
        padding: actionsFillContainer ? Button.Padding.Narrow : Button.Padding.Wide,
        onClick: primaryAction.onClick
      }, primaryAction.buttonProps), primaryAction.text)))));
    }
  }]);

  return ModalContent;
}(React.PureComponent);

_defineProperty(ModalContent, "contextType", ThemingContext);

ModalContent.Sizes = Sizes;
ModalContent.HeaderAlignment = omit(Text.TextAlignments, ['Right', 'Justify']);
var ACTION_PROP = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  buttonProps: PropTypes.object
};
ModalContent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  actionsFillContainer: PropTypes.bool,
  isFullScreenOnMobile: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(ModalContent.Sizes)),
  headerAlignment: DefaultContentHeader.propTypes.headerAlignment,
  primaryAction: PropTypes.shape(ACTION_PROP),
  secondaryAction: PropTypes.shape(ACTION_PROP),
  headerImage: PropTypes.node,
  hasCloseButton: PropTypes.bool,
  hasContentPadding: PropTypes.bool,
  isFooterFixedPosition: PropTypes.bool,
  onClose: PropTypes.func,
  uniqueId: PropTypes.string,
  role: PropTypes.string,
  shouldStackButtons: PropTypes.bool,
  renderContentHeader: PropTypes.func,
  renderFooterContent: PropTypes.func,
  closeOnEsc: PropTypes.bool,
  shouldCloseOnEscapePress: PropTypes.bool
};
ModalContent.defaultProps = {
  size: ModalContent.Sizes.Medium,
  headerAlignment: ModalContent.HeaderAlignment.Left,
  actionsFillContainer: false,
  hasContentPadding: true,
  hasCloseButton: true,
  role: 'dialog',
  renderContentHeader: DefaultContentHeader,
  isFullScreenOnMobile: true,
  shouldCloseOnEscapePress: true,
  shouldStackButtons: false
};
var ModalContentWithUniqueId = withUniqueId(ModalContent, {
  prefix: PREFIX_ID
});
ModalContentWithUniqueId.propTypes = omit(ModalContent.propTypes, ['uniqueId']);
ModalContentWithUniqueId.defaultProps = ModalContent.defaultProps;
ModalContentWithUniqueId.Sizes = ModalContent.Sizes;
ModalContentWithUniqueId.HeaderAlignment = ModalContent.HeaderAlignment;
export default ModalContentWithUniqueId;